export default "__VITE_ASSET__DINyDyJF__"